import { getPublicFileUrl } from "@/lib/api";
import { usePublicLang } from "@/contexts/PublicLangContext";
import ScrollReveal from "./ScrollReveal";
import { LANDING } from "@/constants/testIds";

export default function DoctorSection({ doctor }) {
  const { t } = usePublicLang();
  if (!doctor || (!doctor.photo_url && !doctor.bio && !doctor.specialty)) return null;

  return (
    <section id="doctora" className="py-20 md:py-28 px-5" data-testid={LANDING.doctorSection}>
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        {doctor.photo_url && (
          <ScrollReveal className="order-1">
            <div className="rounded-2xl overflow-hidden aspect-[4/5] max-w-md mx-auto md:mx-0">
              <img src={getPublicFileUrl(doctor.photo_url)} alt={doctor.name} className="w-full h-full object-cover" />
            </div>
          </ScrollReveal>
        )}
        <ScrollReveal delay={0.15} className={`order-2 flex flex-col gap-5 ${!doctor.photo_url ? "md:col-span-2 items-center text-center" : ""}`}>
          <p className="text-xs uppercase tracking-[0.2em] font-medium text-[var(--brand-primary)]">{t("landing.doctor.sectionTitle")}</p>
          <h2 className="font-serif text-3xl md:text-4xl tracking-tight text-[#292522]">{doctor.name}</h2>
          {doctor.specialty && <p className="text-sm font-medium text-[#6B6058]">{doctor.specialty || t("landing.doctor.defaultRole")}</p>}
          {doctor.bio && <p className="text-base md:text-lg leading-relaxed text-[#6B6058] whitespace-pre-line">{doctor.bio}</p>}
        </ScrollReveal>
      </div>
    </section>
  );
}
